<template>
  <Verify :activate="true" @set-auth-state="setAuthState" ref="verify" />
</template>

<script>
import Verify from '@/components/auth/Verify'

export default {
  name: 'Activate',
  components: {
    Verify
  },
  data: () => ({
    email: null
  }),
  methods: {
    setData (email) {
      this.$refs.verify.setData(email)
    },
    setAuthState (data) {
      this.$emit('set-auth-state', {
        state: 'signin',
        message: 'Email verified! Please sign in your account.'
      })
    }
  }
}
</script>
